export default "__VITE_ASSET__5c38a581__"